import KitoToggle from '../../Inputs/Toggle';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function VersionToggle({ route = '/homepage', onVersionChange = () => { } }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const options = [
    {
      value: 0,
      label: 'Adult',
    },
    {
      value: 1,
      label: 'Child',
    },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0].value);

  useEffect(() => {
    const initialVersion = window.localStorage.getItem('@kitoApp/version');
    setSelectedOption(options.find((option) => option.label === (initialVersion || 'Adult')).value);
    if (initialVersion) return;
    window.localStorage.setItem('@kitoApp/version', 'Adult');
  }, []);

  const handleToggleChange = (value) => {
    setSelectedOption(value);
    window.localStorage.setItem('@kitoApp/version', options[value].label);
    window.dispatchEvent(new CustomEvent('kito:version-change', { detail: options[value].label }));
    onVersionChange(options[value].label);
    navigate(route);
  };

  return (
    <KitoToggle
      variant="slider"
      id="user-age"
      checked={selectedOption === 1}
      onChange={(value) => handleToggleChange(Number(value))}
      prefix={t('versionToggle.adult')}
      suffix={t('versionToggle.child')}
    />
  );
}

VersionToggle.propTypes = {
  route: PropTypes.string,
  onVersionChange: PropTypes.func,
};

export default VersionToggle;
